/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PoComboFilter, PoComboOption } from '@po-ui/ng-components';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGenericListAPI } from '../interfaces/IGenericListAPI';

@Injectable({
  providedIn: 'root'
})
export class CityService implements PoComboFilter {
  readonly url = `${environment.url}api/framework/v1/genericList`;
  currentyFilter = '';
  state = '';

  constructor(protected http: HttpClient) {}

  setState(value = ''): void {
    this.state = value;
  }

  getListOfCitys(page: number, pageSize: number, codmun: string, mun?: string): Observable<IGenericListAPI> {
    let filter = `cc2_est eq '${this.state}'`;

    if (mun) {
      filter += ` and ( cc2_codmun eq '${codmun}' or contains(cc2_mun, '${mun}'))`;
    } else if (codmun) {
      filter += ` and cc2_codmun eq '${codmun}'`;
    }

    const params = new HttpParams()
      .append('alias', 'CC2')
      .append('fields', 'cc2_codmun, cc2_mun')
      .append('filter', filter)
      .append('page', page)
      .append('pageSize', pageSize);

    return this.http.get<IGenericListAPI>(this.url, { params });
  }

  getFilteredData(params: any): Observable<PoComboOption[]> {
    this.currentyFilter =
      params.value !== this.currentyFilter && params.page === 1 ? params.value.toString() : this.currentyFilter;
    return this.getListOfCitys(params.page, params.pageSize, this.currentyFilter, this.currentyFilter).pipe(
      map(citys =>
        citys.items.map(city => ({
          value: city.cc2_codmun,
          label: city.cc2_mun
        }))
      )
    );
  }

  getObjectByValue(value: string): Observable<PoComboOption> {
    return this.getListOfCitys(1, 1, value).pipe(
      map(citys =>
        citys.items.map(city => ({
          value: city.cc2_codmun,
          label: city.cc2_mun
        }))
      ),
      map(citys => citys[0])
    );
  }
}
